module.exports = __webpack_public_path__ + "img/img1.c92ac1ec.jpg";